import { call } from 'redux-saga/effects';
import { SelectedScreenshare } from 'features/screenshare/types';
import { RTCClient, ToggleMediaTemplate } from 'utils/webrtc';
import { batchToggleMediaTemplate, sendMessage } from 'utils/webrtc/messages';

export function* unsubscribeFromScreenshareSaga(screenshare: SelectedScreenshare) {
  const feed = RTCClient.getJanusPlugin();

  const { streams } = RTCClient.receivingFeed.media.getFeedStreams(screenshare.feedId);

  // A stream with no subscriberMid was never bound on this handle; sending a
  // configure with a placeholder mid makes Janus reject it with 428 "No such mid".
  const request = Object.values(streams).reduce<ToggleMediaTemplate>((acc, stream) => {
    const { subscriberMid } = stream;

    if (subscriberMid) {
      acc.push({ mid: subscriberMid, send: false });
    }

    return acc;
  }, []);

  if (feed && request.length) {
    yield call(sendMessage, feed, batchToggleMediaTemplate(request));
  }
}
